import { createAction } from '@mews/framework';
import { ServiceOrder } from '@mews-commander/data-access';
import { ApplicationState } from '@mews-commander/types';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createBaseEntitySelectors, createEntitiesReducer } from './utils';

export const NAME = 'serviceOrders';

export const SERVICE_ORDERS_LOADED = prefix('SERVICE_ORDERS_LOADED');
export const SERVICE_ORDERS_UPDATED = prefix('SERVICE_ORDERS_UPDATED');
export const SERVICE_ORDERS_DELETED = prefix('SERVICE_ORDERS_DELETED');

export const setServiceOrders = ({ serviceOrders }: { serviceOrders: ServiceOrder[] }) =>
    createAction(SERVICE_ORDERS_LOADED, { entities: serviceOrders });

export const serviceOrdersReducer = createEntitiesReducer({
    FETCH_SUCCESS: SERVICE_ORDERS_LOADED,
    UPDATE_SUCCESS: SERVICE_ORDERS_UPDATED,
    DELETE_SUCCESS: SERVICE_ORDERS_DELETED,
});

export const [getServiceOrders, getServiceOrdersByIds, getServiceOrdersByOwnerId, getServiceOrder] =
    createBaseEntitySelectors<ApplicationState, ServiceOrder, typeof NAME>(parentSelector, NAME);
